<div (click)="uploadInput.click()" #tooltip="matTooltip" matTooltipClass="default-tooltip"
    [matTooltip]="'texts.Attachment_files_supported' | translate" matTooltipPosition="above"
    matTooltipTouchGestures="auto">
    <i class="fas fa-paperclip attach"></i>
    <input type="file" #uploadInput (change)="loadFile($event.srcElement.files)" [multiple]="true">
</div>